module.exports = __webpack_public_path__ + "static/media/rupee-svg.a2655046.svg";